module.exports = __webpack_public_path__ + "img/arrow.62dbc37e.gif";